import { debounce } from 'lodash';
import React, { useRef } from 'react';
import Spinner from 'react-bootstrap/Spinner';

type PaginationLayoutProps = {
  showMore?: boolean;
  loadMore?: () => void;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const PaginationLayout: React.FunctionComponent<PaginationLayoutProps> = ({
  children,
  showMore,
  loadMore,
  loading,
  className,
  style,
}) => {
  const ref = useRef(null);

  const loadIfAvailable = debounce(
    () => {
      if (ref && ref.current) {
        const height = ref.current.offsetHeight;
        const scrollHeight = ref.current.scrollHeight;
        const offsetBottom = ref.current.lastElementChild.offsetHeight + ref.current.lastElementChild.offsetTop;

        if (height > offsetBottom && height <= scrollHeight && !loading && showMore) {
          loadMore();
        }
      }
    },
    1000,
    { leading: false, trailing: true }
  );

  const loadOnScroll = debounce(
    () => {
      if (ref && ref.current) {
        const height = ref.current.offsetHeight;
        const top = ref.current.scrollTop;
        const scrollHeight = ref.current.scrollHeight;

        if (height + top > scrollHeight - 200 && !loading && showMore) {
          loadMore();
        }
      }
    },
    500,
    { leading: false, trailing: true }
  );

  window.onresize = loadIfAvailable;

  return (
    <div
      className={`h-100 position-relative ${className}`}
      style={{ overflowX: 'hidden', overflowY: 'auto', ...style }}
      ref={ref}
      onLoad={loadIfAvailable}
      onScroll={loadOnScroll}
    >
      {children}
      {showMore || loading ? (
        <div className="text-center small text-muted mt-2">
          {showMore ? (
            loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <span onClick={loadMore} className="c-pointer text-primary">
                Load more
              </span>
            )
          ) : loading ? (
            <Spinner animation="border" size="sm" />
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

PaginationLayout.defaultProps = {
  showMore: false,
  style: {},
  className: '',
};

export default PaginationLayout;
